import { magic } from '@gig/magic-sdk';
import VueRouter, { Route } from 'vue-router';
import { RouteName } from '../../../routes/routes.constants';

export enum AuthRestriction {
    AUTH_REQUIRED,
    AUTH_FORBIDDEN,
    UNRESTRICTED,
}

/*
 * Checks if user is allowed to access a given route
 */
export function isUserAllowed(to: Route) {
    let lastMatched = AuthRestriction.UNRESTRICTED;
    for (const { meta } of to.matched) {
        if (meta.authRestriction !== undefined) {
            lastMatched = meta.authRestriction;
        }
    }

    if (lastMatched === AuthRestriction.UNRESTRICTED) {
        return true;
    }

    const isLoggedIn = !!magic.session.getUser();
    if (lastMatched === AuthRestriction.AUTH_REQUIRED) {
        return isLoggedIn;
    }

    if (lastMatched === AuthRestriction.AUTH_FORBIDDEN) {
        return !isLoggedIn;
    }
}

export function initAuthenticationGuard(router: VueRouter) {
    router.beforeEach(async (to, _, next) => {
        if (isUserAllowed(to)) {
            next();
        } else {
            const isLoggedIn = !!magic.session.getUser();
            if (isLoggedIn) {
                next({
                    name: RouteName.HOME,
                });

                return;
            }

            next({
                name: RouteName.LOGIN,
                params: {
                    language: to.params.language,
                },
                query: {
                    backTo: to.fullPath,
                },
            });
        }
    });
}

export function authenticationGuard(authRestriction: AuthRestriction) {
    return { authRestriction };
}
